import { render, staticRenderFns } from "./PartyQueue.vue?vue&type=template&id=516b8bf9"
import script from "./PartyQueue.vue?vue&type=script&lang=js"
export * from "./PartyQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports